import { requests } from '../../api/services';
import { SUPERVISOR_URL } from '../../utils/Endpoints';

export const SupervisorsService = {
    getSupervisors: (params: any): Promise<any> => requests.get(`${SUPERVISOR_URL}`, params),
    putCalendly: (id: number, params: any): Promise<any> => requests.put(`${SUPERVISOR_URL}/edit/link/${id}`, params),
};
